import type { MotorAd } from '../../types';

export function getBulletPointsText(ad: MotorAd) {
    let output: string[] = [];
    if (ad.dealer_segment) output = output.concat(ad.dealer_segment);
    if (ad.warranty_duration)
        output = output.concat(ad.warranty_duration + ' mnd garanti');
    if (ad.flags?.includes('right_to_exchange'))
        output = output.concat('Bytterett');
    if (ad.service_documents) output = output.concat(ad.service_documents);
    if (ad.hours_used) output = output.concat(ad.hours_used + ' timer');

    return output.join(' ∙ ');
}
